import React from 'react';

const VideoContainer = (props) => {
    const {
        thumbnail,
        onClick
    }= props

    return (
        <div className='w-100 border rounded border-white overflow-hidden cursor-pointer border-accent position-relative bg-gray card-plate' onClick={()=>{onClick(thumbnail)}}>
            <div className="transparent-layer transparent-layer-black">            
            </div>
            <div className="position-absolute absolute-center">
                <div className="icon-container">
                    <h3 className="text-center">
                        <i className="fa fa-play text-white"></i>
                    </h3>
                </div>
            </div>
            {
            thumbnail?<div className='center-image-container'>
                <img src={thumbnail} alt="video image" className="w-100" />
            </div>
            :<div className="text-center">
                <h6 className='text-white'>There is no video</h6>
            </div>
            }
        </div>
    );
}

export default VideoContainer;
